import { Controller } from "@hotwired/stimulus"
import IMask from 'imask'

// Connects to data-controller="phone-mask"
export default class extends Controller {
  connect() {
    this.mask = IMask(this.element, {
      mask: '(000) 000-0000'
    });
  }

  disconnect() {
    this.mask.destroy();
  }
}
